import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';

import './vendor';
import App from './App';

/* posco-multi-lang 적용을 위해 import 필요 */
import '@posco/posco-multi-lang'

ReactDOM.render(
  <Suspense fallback={<div>Loading...</div>}>
    <App />
  </Suspense>
  , document.getElementById('app'));
